import {CSSProperties, FunctionComponent, PropsWithChildren} from 'react';
import styles from './styles.module.scss';

interface ElementProps {
  noBorder?: boolean;
  shadow?: boolean;
  spacing?: 'small' | 'xSmall';
  expandFullHeight?: boolean;
  horizontalCenter?: boolean;
  verticalCenter?: boolean;
  minHeight?: boolean;
  style?: CSSProperties;
  id?: string;
  onClick?: () => void;
  variant?: 'black' | 'brown' | 'glass';
}

const BaseCard: FunctionComponent<PropsWithChildren<ElementProps>> = ({
  children,
  noBorder = false,
  shadow = false,
  spacing,
  expandFullHeight = false,
  horizontalCenter = false,
  verticalCenter = false,
  minHeight = false,
  style,
  id,
  onClick,
  variant = 'black',
}) => {
  let className = `${styles.cardContainer} `;

  if (noBorder) {
    className += `${styles.noBorder} `;
  }

  if (shadow) {
    className += `${styles.shadow} `;
  }

  if (expandFullHeight) {
    className += `${styles.expandFullHeight} `;
  }

  if (horizontalCenter) {
    className += `${styles.horizontalCenter} `;
  }

  if (verticalCenter) {
    className += `${styles.verticalCenter} `;
  }

  if (spacing) {
    className += styles[spacing];
  }

  if (minHeight) {
    className += styles.minHeight;
  }

  if (variant) {
    className += styles[variant];
  }

  return (
    <div className={className} style={style} id={id} onClick={onClick}>
      {children}
    </div>
  );
};

export default BaseCard;
